/**
 * Campaign: Update options for every campaign here
 * If the campaignLink is set, the banner will link to an external website
 * If the couponCode is set, the banner will show the code and a copy button
 * If both are undefined, only the message will be shown on the purchase page
 */
export const campaignOptions: {
  utm_campaign: string
  campaignLink: string | undefined
  startDate: Date
  endDate: Date
  showPromoProButton: boolean
  couponCode: string | undefined
} = {
  utm_campaign: 'valentines-2026',
  startDate: new Date('2026-02-02T00:00:00Z'),
  endDate: new Date('2026-02-16T00:00:00Z'),
  // set to undefined if no link to external website is needed
  campaignLink: undefined,
  // set to undefined if no code is available
  couponCode: 'VALENTINE26',
  showPromoProButton: true,
}

/**
 * Helper utility to check if the campaign is currently active
 */
export function isCampaignActive() {
  const now = new Date()
  return now >= campaignOptions.startDate && now < campaignOptions.endDate
}
